import { GET_INTEGRATION_DATA, GET_INTEGRATION_DATA_SUCCESS, GET_INTEGRATION_DATA_ERROR, GET_INTEGRATION_DATA_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetIntegrationData = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTEGRATION_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_INTEGRATION_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_INTEGRATION_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_INTEGRATION_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetIntegrationData;
